module.exports = __webpack_public_path__ + "static/media/note.ba49c8bd.svg";